(() => {
  const root = document.querySelector('[data-hc-game]');
  if (!root) return;

  const stage = root.querySelector('[data-hc-stage]');
  const ball = root.querySelector('[data-hc-ball]');
  const ballImg = ball.querySelector('img');
  const scoreEl = root.querySelector('[data-hc-score]');
  const finalScoreEl = root.querySelector('[data-hc-final-score]');
  const startBtn = root.querySelector('[data-hc-start]');
  const restartBtn = root.querySelector('[data-hc-restart]');
  const form = root.querySelector('[data-hc-form]');
  const message = root.querySelector('[data-hc-message]');
  const leaderboardEl = root.querySelector('[data-hc-leaderboard]');
  const googleScriptUrl = root.dataset.googleScriptUrl || '';

  const screens = {
    intro: root.querySelector('[data-hc-screen="intro"]'),
    gameover: root.querySelector('[data-hc-screen="gameover"]'),
    leaderboard: root.querySelector('[data-hc-screen="leaderboard"]')
  };

  let playing = false;
  let score = 0;
  let x = 0;
  let y = 0;
  let vx = 0;
  let vy = 0;
  let rotation = 0;
  let spin = 0;
  let last = 0;
  let raf = null;
  let loadingTimer = null;
  let gameStartedAt = null;
  let gameEndedAt = null;
  let hitTimestamps = [];

  function startLoadingText(baseText = 'Kaydediliyor') {
    stopLoadingText();
    let dots = 0;
    message.textContent = `${baseText}.`;
    loadingTimer = window.setInterval(() => {
      dots = (dots % 3) + 1;
      message.textContent = `${baseText}${'.'.repeat(dots)}`;
    }, 420);
  }

  function stopLoadingText(finalText = '') {
    if (loadingTimer) {
      window.clearInterval(loadingTimer);
      loadingTimer = null;
    }
    message.textContent = finalText;
  }

  function show(screen) {
    Object.values(screens).forEach(el => { if (el) el.hidden = true; });
    if (screens[screen]) screens[screen].hidden = false;
    ball.hidden = screen !== 'game';
  }

  function bounds() {
    const rect = stage.getBoundingClientRect();
    const b = ball.getBoundingClientRect();
    return { width: rect.width, height: rect.height, ball: b.width || 110, floor: rect.height - (b.width || 110) / 2 - 20 };
  }

  function positionBall() {
    ball.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`;
    ballImg.style.transform = `rotate(${rotation}deg)`;
  }

  function resetGame() {
    const b = bounds();
    score = 0;
    x = 0;
    y = -b.height * 0.10;
    vx = 0;
    vy = 90;
    rotation = 0;
    spin = 0;
    gameStartedAt = new Date().toISOString();
    gameEndedAt = null;
    hitTimestamps = [];
    updateScore();
    positionBall();
  }

  function updateScore() {
    scoreEl.textContent = String(score);
    finalScoreEl.textContent = String(score);
  }

  function startGame() {
    stopLoadingText('');
    resetGame();
    playing = true;
    last = performance.now();
    show('game');
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(loop);
  }

  function endGame() {
    playing = false;
    gameEndedAt = new Date().toISOString();
    cancelAnimationFrame(raf);
    updateScore();
    show('gameover');
  }

  function loop(now) {
    if (!playing) return;
    const dt = Math.min((now - last) / 1000, 0.034);
    last = now;
    const b = bounds();
    const radius = b.ball / 2;
    vy += 1120 * dt;
    vx *= Math.pow(0.996, dt * 60);
    spin *= Math.pow(0.991, dt * 60);
    x += vx * dt;
    y += vy * dt;
    rotation += (spin + (vx / Math.max(radius, 1)) * 57.2958) * dt;
    const sideLimit = (b.width / 2) - radius - 12;
    if (x < -sideLimit) { x = -sideLimit; vx = Math.abs(vx) * 0.72; spin += vx * 0.36; }
    if (x > sideLimit) { x = sideLimit; vx = -Math.abs(vx) * 0.72; spin += vx * 0.36; }
    const centerBasedFloor = b.floor - b.height / 2;
    if (y >= centerBasedFloor) { y = centerBasedFloor; positionBall(); endGame(); return; }
    positionBall();
    raf = requestAnimationFrame(loop);
  }

  function hitBall(event) {
    if (!playing) return;
    event.preventDefault();
    const rect = ball.getBoundingClientRect();
    const pointerX = event.clientX || (event.touches && event.touches[0]?.clientX) || rect.left + rect.width / 2;
    const pointerY = event.clientY || (event.touches && event.touches[0]?.clientY) || rect.top + rect.height / 2;
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const radius = rect.width / 2;
    const hitX = Math.max(-1, Math.min(1, (pointerX - centerX) / radius));
    const hitY = Math.max(-1, Math.min(1, (pointerY - centerY) / radius));
    const distance = Math.min(1, Math.hypot(hitX, hitY));
    score += 1;
    hitTimestamps.push(Date.now());
    updateScore();
    const baseLift = Math.max(560, 710 - Math.min(score, 40) * 4);
    vy = -baseLift * (1 + distance * 0.10);
    const lateralImpulse = -hitX * (310 + distance * 210);
    vx = Math.max(-560, Math.min(560, vx * 0.38 + lateralImpulse));
    const torque = (hitX * -980) + (hitY * hitX * -420);
    spin = Math.max(-1500, Math.min(1500, spin * 0.35 + torque));
    ball.classList.add('is-hit');
    window.setTimeout(() => ball.classList.remove('is-hit'), 90);
  }

  function getHitIntervals() {
    const intervals = [];
    for (let i = 1; i < hitTimestamps.length; i += 1) {
      intervals.push(hitTimestamps[i] - hitTimestamps[i - 1]);
    }
    return intervals.slice(-250);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[<>&"]/g, char => ({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[char]));
  }

  function renderBoard(entries) {
    const safeEntries = Array.isArray(entries) ? entries : [];
    const combined = safeEntries
      .filter(entry => entry && Number.isFinite(Number(entry.score)))
      .sort((a, b) => Number(b.score) - Number(a.score))
      .slice(0, 10);

    if (!combined.length) {
      leaderboardEl.innerHTML = '<li><span>Henüz kayıtlı skor yok.</span><strong>0</strong></li>';
      return;
    }

    leaderboardEl.innerHTML = combined.map((entry, index) => {
      const name = escapeHtml(entry.displayName || entry.name || 'Player');
      return `<li><span>${index + 1}. ${name}</span><strong>${Number(entry.score || 0)}</strong></li>`;
    }).join('');
  }

  async function fetchRemoteLeaderboard() {
    if (!googleScriptUrl) {
      renderBoard([]);
      return false;
    }
    const response = await fetch(`${googleScriptUrl}?action=leaderboard&limit=10&ts=${Date.now()}`, { method: 'GET' });
    const data = await response.json();
    if (!data || !data.ok) throw new Error(data && data.error ? data.error : 'Leaderboard could not be loaded');
    renderBoard(data.leaderboard || []);
    return true;
  }

  async function submitToGoogleSheets(payload) {
    if (!googleScriptUrl) throw new Error('Google Script URL is missing');

    const response = await fetch(googleScriptUrl, {
      method: 'POST',
      redirect: 'follow',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    });

    let data = null;
    try { data = await response.json(); } catch (_) {}
    if (!response.ok || !data || !data.ok) {
      throw new Error(data && data.error ? data.error : 'Google Sheets save failed');
    }
    return data;
  }

  startBtn.addEventListener('click', startGame);
  restartBtn.addEventListener('click', startGame);
  ball.addEventListener('pointerdown', hitBall, { passive: false });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const data = new FormData(form);
    const firstName = String(data.get('firstName') || '').trim();
    const lastName = String(data.get('lastName') || '').trim();
    const email = String(data.get('email') || '').trim().toLowerCase();
    if (!firstName || !lastName || !email) { stopLoadingText('Lütfen tüm alanları doldur.'); return; }

    const endedAt = gameEndedAt || new Date().toISOString();
    const durationMs = gameStartedAt ? Math.max(0, new Date(endedAt).getTime() - new Date(gameStartedAt).getTime()) : 0;
    const hitIntervals = getHitIntervals();

    const entry = {
      firstName,
      lastName,
      fullName: `${firstName} ${lastName}`,
      email,
      score,
      consent: data.get('consent') === 'on',
      createdAt: new Date().toISOString(),
      source: 'hatton-world-cup-game',
      userAgent: navigator.userAgent,
      gameStartedAt,
      gameEndedAt: endedAt,
      durationMs,
      hitCount: hitTimestamps.length,
      hitIntervals,
      avgHitIntervalMs: hitIntervals.length ? Math.round(hitIntervals.reduce((sum, value) => sum + value, 0) / hitIntervals.length) : null,
      minHitIntervalMs: hitIntervals.length ? Math.min(...hitIntervals) : null,
      gameVersion: '1.1.0'
    };

    startLoadingText('Kaydediliyor');
    try {
      await submitToGoogleSheets(entry);
      await fetchRemoteLeaderboard();
      form.reset();
      stopLoadingText('');
      show('leaderboard');
    } catch (error) {
      stopLoadingText('Kayıt alınamadı. Lütfen tekrar dene veya sayfayı yenile.');
      console.error('Hatton game save error:', error);
    }
  });

  fetchRemoteLeaderboard().catch(() => renderBoard([]));
  show('intro');
})();
